import { Component, inject } from '@angular/core'

import { HuntPackageOverviewComponent } from '../../../../../../../modules/shared/components/hunt-package-overview/hunt-package-overview.component'
import { PackageViewService } from '../../../../../services/reader/package-view.service'

@Component({
  standalone: true,
  selector: 'default-overview-tab',
  imports: [HuntPackageOverviewComponent],
  templateUrl: './overview-tab.component.html',
  styleUrls: ['./overview-tab.component.scss'],
})
export class OverviewTabComponent {
  private readonly pkgView = inject(PackageViewService)

  readonly pkg = this.pkgView.activePackage
}
